import { Link } from "react-router-dom";

const modules = [
    {
        id: "raw-data-qc",
        name: "Raw Data QC",
    },
    {
        id: "chipseq",
        name: "Epigenome Profiling (ChIP-Seq)",
    },
    {
        id: "transcriptome-model",
        name: "Transcriptome Resequencing",
    },
    {
        id: "variant-analysis",
        name: "Variant Analysis",
    },
    {
        id: "exome",
        name: "Exome / Targeted Sequencing",
    },
    {
        id: "metagenome",
        name: "Metagenome",
    },
];

export default function SampleReportsPage() {
    return (
        <div className="max-w-7xl mx-auto space-y-6">
            <div>
                <h1 className="text-2xl font-bold text-gray-900">
                    Sample Reports
                </h1>

                <p className="mt-1 text-gray-600">
                    Select a module to view its sample report.
                </p>
            </div>

            <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
                {modules.map((module) => (
                    <div
                        key={module.id}
                        className="rounded-xl border border-gray-200 bg-white p-6 transition-all hover:border-[#0B6936] hover:shadow-md"
                    >
                        <h2 className="text-lg font-semibold text-gray-900">
                            {module.name}
                        </h2>

                        <div className="mt-4 flex flex-wrap gap-2">
                            <Link
                                to={`/app/sample-reports/${module.id}`}
                                className="inline-flex items-center rounded-md border border-[#0B6936] px-4 py-2 text-sm font-semibold text-[#0B6936] transition hover:bg-[#0B6936] hover:text-white"
                            >
                                View Report
                            </Link>
                            <a
                                href={`/sample-reports/${module.id}.html`}
                                download
                                className="inline-flex items-center rounded-md bg-[#0B6936] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#09522f]"
                            >
                                Download
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}